var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-nav-layout"},[_c('SideNavBar'),_c('div',{staticClass:"top-bar-layout"},[_c('simplebar',{staticClass:"layout-contents",attrs:{"data-simplebar-auto-hide":"true"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }